import React from "react";
import {HomeContainer} from "../container/home"; 

export default function Home(){
    return (
        <HomeContainer />
    )
}